import { extensions, view } from '@yola/ws-sdk';
import debounce from 'lodash.debounce';
import constants from '../../extensions/registry/ws-online-store/constants';

const refreshDesignAdaptationConfig = debounce((onlineStore) => {
  onlineStore.refreshDesignAdaptationConfig();
}, 300);

const refreshStore = () => {
  const onlineStoreSettings = extensions.accessors.getExtensionSettings(constants.common.slug);
  const liveDocument = view.accessors.getLiveDocument();
  const onlineStore = liveDocument.querySelector(onlineStoreSettings.querySelector);

  if (onlineStore) {
    refreshDesignAdaptationConfig(onlineStore); // Use the debounced function
  }
};

export default refreshStore;
